import React from 'react'

//Menu
import HomeIcon from '@mui/icons-material/Home';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import PaidIcon from '@mui/icons-material/Paid';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GavelIcon from '@mui/icons-material/Gavel';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

//Others
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupIcon from '@mui/icons-material/Group';

export const SidebarDataMenu = [
    {
        title: "Home",
        icon: <HomeIcon />,
        link: "/"
    },
    {
        title: "Personnel",
        icon: <ManageAccountsIcon />,
        children: [
            {
                name: "Add Employee",
                link: "/addEmployee"
            },
            {
                name: "Employee Information",
                link: "/employeeInformation"
            },
            {
                name: "Employee List",
                link: "/employeesList"
            },
            {
                name: "Employment Status",
                link: "/employmentStatus"
            },
            {
                name: "Employee Schedule",
                link: "/employeeSchedule"
            },
            {
                name: "Employee Reliever",
                link: "/employeeReliever"
            },
            {
                name: "Relationship Disclosure List",
                link: "/relationshipDisclosure"
            },
            {
                name: "PRC License",
                link: "/prcLicense"
            },
            /* {
                name: "Employee Requirements",
                link: "/employeeRequirements"
            }, */
        ]
    },
    {
        title: "Time Keeping",
        icon: <AccessTimeFilledIcon />,
        children: [
            {
                name: "Time Entries",
                link: "/timeKeeping"
            },
            {
                name: "Tampered Approval",
                link: "/tamperedApproval"
            },
            {
                name: "Shift Schedule",
                link: "/shiftSchedule"
            },
            {
                name: "Payroll Period",
                link: "/payrollPeriod"
            },
        ]
    },
    {
        title: "Payroll",
        icon: <PaidIcon />,
        children: [
            {
                name: "Process Payroll",
                link: "/payroll"
            },
            {
                name: "Final Pay",
                link: "/finalPay"
            },
            {
                name: "Subcon",
                link: "/subcon"
            },
            {
                name: "Agency",
                link: "/agency"
            },
        ]
    },
    {
        title: "Maintenance",
        icon: <EngineeringIcon />,
        children: [
            /* {
                name: "Announcement",
                link: "/announcement"
            }, */
            {
                name: "Pay Type",
                link: "/payType"
            },
            {
                name: "Holiday",
                link: "/holiday"
            },
            {
                name: "Holiday Type",
                link: "/holidayType"
            },
            {
                name: "Leave Types",
                link: "/leaveTypes"
            },
            {
                name: "Department",
                link: "/department"
            },
            {
                name: "Section",
                link: "/section"
            },
            {
                name: "Classification",
                link: "/classification"
            },
            {
                name: "Company",
                link: "/company"
            },
            {
                name: "Position",
                link: "/position"
            },
            {
                name: "Employee Status",
                link: "/employeeStatus"
            },
            {
                name: "Job Title",
                link: "/jobTitle"
            },
            {
                name: "Employee Group 1",
                link: "/employeeGroup1"
            },
            {
                name: "Employee Group 2",
                link: "/employeeGroup2"
            },
            {
                name: "Location",
                link: "/location"
            },
            {
                name: "DTR Rules Configuration",
                link: "/dtrRulesConfiguration"
            },
            {
                name: "Time Keeper",
                link: "/timeKeeper"
            },
            {
                name: "Plantilya",
                link: "/plantilya"
            },
        ]
    },
    {
        title: "Salary Module",
        icon: <AccountBalanceIcon />,
        children: [
            {
                name: "Employee Monthly Salary",
                link: "/employeeMonthlySalary"
            },
            {
                name: "Employee Daily Salary",
                link: "/employeeDailySalary"
            },
            {
                name: "Position - Designation Salary",
                link: "/positionDesignationSalary"
            },
            {
                name: "Position - Designation Salary (La Union)",
                link: "/positionDesignationSalaryLaUnion"
            },
            {
                name: "Employee Bank Account",
                link: "/employeeBankAccount"
            },
            {
                name: "Salary Complaint List",
                link: "/salaryComplaint"
            }
        ]
    },
    {
        title: "Government Premiums",
        icon: <GavelIcon />,
        children: [
            {
                name: "BIR / Tax",
                link: "/tax"
            },
            {
                name: "Pagibig",
                link: "/pagibig"
            },
            {
                name: "SSS",
                link: "/sss"
            },
            {
                name: "Philheath",
                link: "/philhealth"
            },
        ]
    },
    {
        title: "Transactions",
        icon: <ReceiptIcon />,
        children: [
            {
                name: "DTR (Admin's View)",
                link: "/dtr"
            },
            {
                name: "DTR (Employee's View)",
                link: "/dtrBiometrics"
            },
            {
                name: "DTR With OT Viewing",
                link: "/dtrWithOTViewing"
            },
            {
                name: "Offset Credits",
                link: "/offsetCredits",
            },
            {
                name: "Mobile DTR Approval",
                link: "/mobileDTRApproval"
            },
            {
                name: "Approver Hierarchy",
                link: "/approverHierarchy"
            },
            {
                name: "Approver Hierarchy Per Location",
                link: "/approverHierarchyPerLocation"
            },
            {
                name: "Mass Approval",
                link: "/massApproval"
            },
            {
                name: "Request Approval",
                link: "/requestApproval"
            },
            {
                name: "Request Approval Time Keeper",
                link: "/requestApprovalTimeKeeper"
            },
            {
                name: "DTR Correction Workers",
                link: "/dtrCorrectionWorkers"
            },
            {
                name: "Overtime",
                link: "/overtime"
            },
            {
                name: "DTR Correction",
                link: "/dtrCorrection"
            },
            {
                name: "Official Business",
                link: "/officialBusiness"
            },
            {
                name: "Leave",
                link: "/leave"
            },
            {
                name: "Offset Request / Overtime Food Allowance",
                link: "/offsetRequest",
            },
            {
                name: "Relationship Disclosure",
                link: "/relationshipDisclosureRequest"
            },
            {
                name: "Salary Complaint",
                link: "/salaryComplaintRequest"
            },
            {
                name: "Change of Schedule",
                link: "/changeOfSchedule"
            },
        ]
    },
    {
        title: "Loans & Benefits",
        icon: <CreditScoreIcon />,
        children: [
            {
                name: "SSS Loan",
                link: "/sssLoan"
            },
            {
                name: "SSS Calamity Loan",
                link: "/sssCalamityLoan"
            },
            {
                name: "Pagibig Loan",
                link: "/pagibigLoan"
            },
            {
                name: "Pagibig Calamity Loan",
                link: "/pagibigCalamityLoan"
            },
            {
                name: "Cash Advance",
                link: "/cashAdvance"
            },
            {
                name: "Loans",
                link: "/loans"
            },
            {
                name: "Deductions",
                link: "/deductions"
            },
            {
                name: "Benefits",
                link: "/benefits"
            },
        ]
    },
]

export const SidebarDataOthers = [
    {
        title: "Reports",
        icon: <ReportProblemIcon />,
        children: [
            {
                name: "Man Hour",
                link: "/manHour"
            },
            {
                name: "Yearly Report",
                link: "/yearlyReport"
            },
            {
                name: "BIR Form No. 2316",
                link: "/BIR2316"
            },
            {
                name: "BIR Form No. 1601C",
                link: "/BIR1601C"
            },
            {
                name: "Alphalist",
                link: "/alphalist"
            },
            {
                name: "Per Day Tracker",
                link: "/perDayTracker"
            },
            {
                name: "Overtime Summary Report",
                link: "/overtimeSummaryReport"
            },
            {
                name: "Tracker Report",
                link: "/trackerReport"
            },
            {
                name: "Payslip",
                link: "/payslip"
            },
            {
                name: "Payroll Register",
                link: "/payrollRegister"
            },
            {
                name: "Resigned",
                link: "/resigned"
            },
            {
                name: "Active Employees",
                link: "/activeEmployees"
            },
            {
                name: "Year of Service",
                link: "/yearOfService"
            },
            {
                name: "SSS Summary",
                link: "/sss-report"
            },
            {
                name: "Pagibig Summary",
                link: "/pagibig-report"
            },
            {
                name: "Philhealth Summary",
                link: "/philhealth-report"
            },
            {
                name: "SSS Loan Report",
                link: "/sssLoan-report"
            },
            {
                name: "Pagibig Loan Report",
                link: "/pagibigLoan-report"
            },
            {
                name: "201 Report",
                link: "/201report"
            },
            {
                name: "Attendance Report",
                link: "/attendanceReport"
            },
            {
                name: "Bank Transmittal BDO",
                link: "/bankTransmittalBDO"
            },
            {
                name: "Bank Transmittal BPI",
                link: "/bankTransmittalBPI"
            },
            {
                name: "Bank Transmittal China Bank Savings",
                link: "/bankTransmittalChinaBankSavings"
            },
            {
                name: "Bank Transmittal HSBC",
                link: "/bankTransmittalHSBC"
            },
            {
                name: "Bank Transmittal Security Bank",
                link: "/bankTransmittalSecurityBank"
            },
            {
                name: "Summary Of Tardiness",
                link: "/summaryOfTardiness"
            },
            {
                name: "Absences Memo",
                link: "/absencesMemo"
            },
            {
                name: "Absences Report",
                link: "/absencesReport"
            },
            {
                name: "Action History Report",
                link: "/actionHistoryReport"
            },
            {
                name: "Allowance Summary",
                link: "/allowanceSummary"
            },
            {
                name: "Audit Trail Report - Employee Setup",
                link: "/auditTrailReportEmployeeSetup"
            },
            {
                name: "Bundy Clock Usage",
                link: "/bundyClockUsage"
            },
            {
                name: "Basic Pay Adjustment Report",
                link: "/basicPayAdjustmentReport"
            },
            {
                name: "Certificate Of Employment",
                link: "/certificateOfEmployment"
            },
            {
                name: "Certificate Of Pagibig",
                link: "/certificateOfPagibig"
            },
            {
                name: "Certificate Of Philhealth",
                link: "/certificateOfPhilhealth"
            },
            {
                name: "Certificate Of SSS",
                link: "/certificateOfSSS"
            },
            {
                name: "Commissions Summary",
                link: "/commissionsSummary"
            },
            {
                name: "Cost Center Report",
                link: "/costCenterReport"
            },
            {
                name: "Deductions Per Month",
                link: "/deductionsPerMonth"
            },
            {
                name: "DTR Report",
                link: "/dtrReport"
            },
            {
                name: "Earnings Per Month",
                link: "/earningsPerMonth"
            },
            {
                name: "Employee Leave Group",
                link: "/employeeLeaveGroup"
            },
            {
                name: "Employee Overtime Group",
                link: "/employeeOvertimeGroup"
            },
            {
                name: "Employee Expense Group",
                link: "/employeeExpenseGroup"
            },
            {
                name: "Employee Leave History",
                link: "/employeeLeaveHistory"
            },
            {
                name: "Employee Listing By Hiring Date",
                link: "/employeeListingByHiringDate"
            },
            {
                name: "Employee Register",
                link: "/employeeRegister"
            },
            {
                name: "Expense Report",
                link: "/expenseReport"
            },
            {
                name: "Government Employee Inventory",
                link: "/governmentEmployeeInventory"
            },
            {
                name: "Headcount Report",
                link: "/headcountReport"
            },
            {
                name: "Holiday Premium Summary",
                link: "/holidayPremiumSummary"
            },
            {
                name: "Leave Ledger Report",
                link: "/leaveLedgerReport"
            },
            {
                name: "Leave Summary Report",
                link: "/leaveSummaryReport"
            },
            {
                name: "Loan History",
                link: "/loanHistory"
            },
            {
                name: "Loan Payments Summary",
                link: "/loanPaymentsSummary"
            },
            {
                name: "Loans Monthly Amortization Summary",
                link: "/loansMonthlyAmmortizationSummary"
            },
            {
                name: "Loans Penalty History",
                link: "/loansPenaltyHistory"
            },
            {
                name: "Night Differential Summary",
                link: "/nightDifferentialSummary"
            },
            {
                name: "Non Taxable Allowances Report",
                link: "/nonTaxableAllowancesReport"
            },
            {
                name: "Other Earnings Report",
                link: "/otherEarningsReport"
            },
            {
                name: "Other Deductions Summary",
                link: "/otherDeductionsSummary"
            },
            {
                name: "Outstanding Loans",
                link: "/outstandingLoans"
            },
            {
                name: "Payroll Cash Register",
                link: "/payrollCashRegister"
            },
            {
                name: "Payroll Check Register",
                link: "/payrollCheckRegister"
            },
            {
                name: "Payroll Debit Memo",
                link: "/payrollDebitMemo"
            },
            {
                name: "Payroll Journal By Cost Center",
                link: "/payrollJournalByCostCenter"
            },
            {
                name: "Payroll Journal By Department",
                link: "/payrollJournalByDepartment"
            },
            {
                name: "Payroll Journal By Summary",
                link: "/payrollJournalBySummary"
            },
            {
                name: "Payroll Per Payment Method",
                link: "/payrollPerPaymentMethod"
            },
            {
                name: "Select Logs",
                link: "/selectLogs"
            },
            {
                name: "Summary Report By Month And Department",
                link: "/summaryReportByMonthAndDepartment"
            },
            {
                name: "Tardiness Memo",
                link: "/tardinessMemo"
            },
            {
                name: "Time Keeping History Detailed Report",
                link: "/timeKeepingHistoryDetailedReport"
            },
            {
                name: "Time Keeping Hours Worked Report",
                link: "/timeKeepingHoursWorkedReport"
            },
            {
                name: "Time Keeping Hours Worked Summary",
                link: "/timeKeepingHoursWorkedSummary"
            },
            {
                name: "Timesheet Status Report",
                link: "/timesheetStatusReport"
            },
            {
                name: "YTD Deduction Summary",
                link: "/ytdDeductionSummary"
            },
            {
                name: "YTD Earnings Summary",
                link: "/ytdEarningsSummary"
            },
            {
                name: "YTD Payroll Register",
                link: "/ytdPayrollRegister"
            },
        ]
    },
    {
        title: "Settings",
        icon: <SettingsIcon />,
        link: "/settings"
    },
    {
        title: "Calendar",
        icon: <CalendarMonthIcon />,
        link: "/calendar"
    },
    {
        title: "Users",
        icon: <GroupIcon />,
        link: "/users"
    }
]

export const extractMenuItems = (menu) => {
    return menu.flatMap(item => item.children ? item.children.map(child => ({ name: child.name, link: child.link })) : [{ name: item.title, link: item.link }]);
};